import React from 'react';
import { Head } from '@inertiajs/react';
import PostForm from '@/components/admin/blog/PostForm';

interface Author {
  id: number;
  name: string;
  email: string;
}

interface Category {
  id: number;
  name: string;
  slug: string;
}

interface Tag {
  id: number;
  name: string;
  slug: string;
}

interface Post {
  id: number;
  title: string;
  slug: string;
  summary: string;
  content: string;
  ai_markdown: string;
  tiptap_json: Record<string, unknown>;
  content_html: string;
  cover_image: string;
  status: 'draft' | 'published' | 'archived';
  visibility: 'visible' | 'auth_only';
  published_at: string | null;
  author: Author;
  category_ids: number[];
  tag_ids: number[];
}

interface Props {
  post: Post;
  categories: Category[];
  tags: Tag[];
}

const Edit: React.FC<Props> = ({ post, categories, tags }) => {
  return (
    <>
      <Head title={`Edit: ${post.title}`} />
      <PostForm post={post} categories={categories} tags={tags} isEditing={true} />
    </>
  );
};

export default Edit;
